import { Loader } from "../carbon-ui";

export const suspenseLoader = () => (
  <Loader />
);
